export default __webpack_public_path__ + "static/HVO-d4ff870ed20d06d0a80a9e5e26f681ca.png";